import { render, staticRenderFns } from "./tongyong.vue?vue&type=template&id=d7e52980&"
import script from "./tongyong.vue?vue&type=script&lang=ts&"
export * from "./tongyong.vue?vue&type=script&lang=ts&"
import style0 from "./tongyong.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports